export { BarcodeScannerModule } from './barcode-scanner.module';
export { BarcodeScannerComponent } from './barcode-scanner.component';
